import {
  ClaimDefine,
  getAriesClaimSDK as getAriesClaimSDKInner,
  getAriesSDK as getAriesSDKInner,
  getAriesWrapperSDK as getAriesWrapperSDKInner,
} from '@aries-markets/aries-tssdk';

import { AptosProvider } from '@aries-markets/create-sdk';
import { AptosSDK } from '@aries-markets/create-sdk/dist/aptos/sdk';
import { getAriesProgram } from '../lending/market';
import { getProviderHub } from './aptos-provider';

const getAriesSDKMemo = (provider: AptosProvider, program: string) =>
  getAriesSDKInner(provider, program);

const getWrapperSDKMemo = (provider: AptosProvider, program: string) =>
  getAriesWrapperSDKInner(provider, program);

export const getAriesSDK = (program?: string) => {
  const ariesSDK = getAriesSDKMemo(
    getProviderHub()?.provider!,
    program || getAriesProgram(),
  );
  const wrapperSDK = getWrapperSDKMemo(
    getProviderHub()?.provider!,
    program || getAriesProgram(),
  );
  return {
    ...ariesSDK,
    extern: { ...wrapperSDK.wrapped_controller },
  };
};

export const getLPTokenAddress = (coinType: string) =>
  `${getAriesProgram()}::lp::LP<${coinType}>`;

export const getClaimSDK = (program: string): AptosSDK<ClaimDefine> => {
  const sdk = getAriesClaimSDKInner(getProviderHub()?.provider!, program);
  return sdk;
};
